<template>
  <!-- 注册 -->
  <div class="box">
    <div class="content">
      <!-- is_private 更改一些样式 -->
      <img class="reg-img" :class="{'is_private': (!HAVE_PHONE)}" src="../../views/registration/assets/images/register_zhuce.png" alt="">
      <el-form :model="fromData" ref="fromData" @submit.native.prevent :rules="rules">
        <!-- 手机号 -->
        <template v-if="test==='userPone'">
          <el-form-item prop="loginPhone">
            <el-input v-model.trim="fromData.loginPhone" @keyup.enter.native="handleTest" placeholder="请输入11位手机号"></el-input>
          </el-form-item>
        </template>
        <!-- 邮箱 -->
        <template v-if="test==='userEmail'">
          <el-form-item prop="loginEmail" :key="2">
            <el-input v-model.trim="fromData.loginEmail" @keyup.enter.native="handleTest" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <el-button class="regcode" @click="handleTest" type="primary">验证</el-button>

      <!-- 独立部署不需要勾选 -->
      <div class="checkbox-box" v-if="HAVE_PHONE">
        <el-checkbox v-model="checked"></el-checkbox>
        <span class="text" @click="handleAgree"> 同意飞译人机合译平台</span>
        <a class="text-blure" :href="SERVE_URL" target="_blank"> 用户隐私政策</a>
      </div>
    </div>
  </div>
</template>
<script>
import { registerUserAccount, registerEmailAccount } from '@/services/loginRegister';
export default {
  name: "register",
  props: {
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    },
    // // 注册类别 只读属性
    userTest: {
      type: String,
      required: true
    },
  },
  data() {
    // 手机号验证
    const testPone = (rule, value, callback) => {
      // const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (value === "") {
        callback(new Error('请输入手机号码'));
      } else if (!reg.test(value)) {
        callback(new Error('手机号码格式错误'));
      } else {
        callback();
      }
    }
    // 邮箱验证
    const testEmail = (rule, value, callback) => {
      // const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (value === "") {
        callback(new Error('请输入邮箱'))
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式错误'))
      } else {
        callback()
      }
    }
    return {
      test: this.userTest, //默认手机号码验证
      HAVE_PHONE: HAVE_PHONE, //独立部署
      fromData: { //表单数据
        loginPhone: "",
        loginEmail: ""
      },
      SERVE_URL: 'https://gen.fycat.com/h5/serveClause.html',
      checked: false,//复选框状态
      activeNum: this.stepActive, // 设置显示
      rules: {
        loginPhone: [
          { validator: testPone, trigger: 'blur' },
        ],
        loginEmail: [
          { validator: testEmail, trigger: 'blur' },
        ]
      },//验证规则
    }
  },
  created() { },
  mounted() { },
  methods: {
    handleEnter () {
      console.log(1545);
    },
    // 点击验证
    handleTest() {
      if ((!this.checked) && (this.HAVE_PHONE)) {
        this.$message.closeAll()
        this.$message({
          message: '请先详细阅读并勾选同意飞译人机合译平台用户隐私政策',
          type: 'error'
        })
        return
      }
      if (this.test === 'userPone') {//手机号注册
        this.$refs.fromData.validateField('loginPhone', async (valid) => {
          if (valid !== '') {
            return
          }
          let data = JSON.parse(JSON.stringify(this.fromData))
          for (const key in data) {
            if (!data[key]) {
              delete data[key]
            }
          }
          // 接口参数
          const params = {
            loginPhone: data.loginPhone,
            mustNotExist: true
          }
          if (params.loginPhone) {
            const { success } = await registerUserAccount(params)
            if (success) {
              // 向父组件传递输入的电话号码
              this.$emit('sendUserInfo', data)
              // 改变步骤条
              this.$emit('setStepActive', ++this.activeNum)
            }
          }
        })
      } else { //邮箱注册 loginEmail
        this.$refs.fromData.validateField('loginEmail', async (valid) => {
          if (valid !== '') {
            return
          }
          let data = JSON.parse(JSON.stringify(this.fromData))
          for (const key in data) {
            if (!data[key]) {
              delete data[key]
            }
          }
          // 接口参数
          const params = {
            email: data.loginEmail,
            mustNotExist: true
          }
          if (params.email) {
            const { success } = await registerEmailAccount(params)
            if (success) {
              // 向父组件传递输入的邮箱号码
              this.$emit('sendUserInfo', data)
              // 改变步骤条
              this.$emit('setStepActive', ++this.activeNum)
            }
          }
        })
      }
    },
    // 点击勾选
    handleAgree() {
      this.checked = !this.checked
    }
  }
}
</script>
<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../views/registration/assets/images/register_bg1.png")
    no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin: 69px 0 19px 0;
      width: 100px;
      height: 40px;
    }
    .is_private {
      margin: 69px 0 50px 0;
    }
    /deep/.el-form {
      .el-form-item {
        .el-input__inner {
          width: 310px;
          height: 46px;
          border-radius: 8px;
          &::placeholder {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            opacity: 0.8;
          }
        }
      }
    }
    .regcode {
      display: flex;
      justify-content: center;
      width: 310px;
      height: 46px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #fff;
      background: #0078fc;
      border-radius: 8px;
      &:hover {
        background: #3393fd;
        border-color: #3393fd;
      }
      &:active {
        background: #006ce3;
        border-color: #006ce3;
      }
    }
    .checkbox-box {
      margin-top: 21px;
      width: 310px;
      height: 15px;
      text-align: left;
      /deep/ .el-checkbox {
        height: 14px;
        .el-checkbox__inner {
          width: 14px;
          height: 14px;
          border-radius: 4px;
          color: #999999;
        }
      }
      .text {
        width: 150px;
        height: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 15px;
        margin-left: 5px;
        cursor: pointer;
      }
      .text-blure {
        height: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0078fc;
        line-height: 15px;
        cursor: pointer;
      }
    }
  }
}
</style>